import WithTooltip from "./WithTooltip";

// TODO remove this
export default WithTooltip;
